import { isAppSource } from "./getSourceFromUrl";

/**
 * Opens an external URL (e.g. the prefilled Zendesk form) in a new window.
 *
 * Must be called synchronously inside the click handler (before any `await`),
 * otherwise popup blockers (Safari, Firefox) will block it.
 *
 * In the mobile app (`?source=app`), the webview cannot open the device's browser
 * without native support, so nothing is opened.
 *
 * @returns false if nothing was opened (mobile app or popup blocked): the caller should
 * then navigate to the URL in the current view.
 */
export const openExternalUrl = (url: string): boolean => {
  if (isAppSource()) return false;

  // `noopener` in the features string would make window.open return null even on success,
  // so the opener is cut manually to keep the blocked-popup detection.
  const newWindow = window.open(url, "_blank");
  if (!newWindow) return false;

  newWindow.opener = null;
  return true;
};
